import React, { Fragment, useEffect, useMemo, useRef, useState } from "react";
import { DataType, SortingMode } from "ka-table/enums";
import dayjs from "dayjs";
import { kaReducer, Table } from "ka-table";
import { updateData } from "ka-table/actionCreators";
import { useDispatch, useSelector } from "react-redux";
import {
  editConfig,
  getDataQuality,
  getDownloadJobs,
  getJobData,
  getLiveJobList,
  jobAction,
  resumeJob,
  setCreateJobs,
} from "../../Utils/actions";
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import LastPageIcon from "@mui/icons-material/LastPage";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import FormControl from "@mui/material/FormControl";
import { Select, MenuItem, TextField } from "@mui/material";
import { Row } from "react-bootstrap";
import {
  FormGroup,
  FormControlLabel,
  Button,
  Box,
  Switch,
  IconButton,
  TableBody,
  TableRow,
  TableCell,
  TableHead,
  Tooltip,
} from "@material-ui/core";
import { AppBar, Tab, Tabs } from "@mui/material";
import TabPanel from "../../Pages/YH/TabPanel";
import FullscreenIcon from "@mui/icons-material/Fullscreen";
import {
  AiOutlinePlayCircle,
  AiOutlineReload,
  AiOutlineCloseCircle,
  AiOutlineEdit,
} from "react-icons/ai";
import { FaRegStopCircle } from "react-icons/fa";
import { useTranslation } from "react-i18next";
// import { Switch } from "@mui/material";
import _ from "lodash";
import { tabStyle, tabsStyle } from "../../Style/ManualStyle";
import AllOutIcon from "@mui/icons-material/AllOut";
import { Link } from "@mui/material";
import HouseIcon from "@mui/icons-material/House";
import { useLocation, useNavigate } from "react-router-dom";
import {
  MaterialReactTable,
  MRT_ToolbarInternalButtons,
} from "material-react-table";
import "../../index.scss";
import PieChartOutlineIcon from "@mui/icons-material/PieChartOutline";
import {
  Add as AddIcon,
  Edit as EditIcon,
  Delete as DeleteIcon,
} from "@mui/icons-material";
import { loadingOn } from "../../Utils/utils";
import StopCircleOutlinedIcon from "@mui/icons-material/StopCircleOutlined";
import PlayCircleOutlineOutlinedIcon from "@mui/icons-material/PlayCircleOutlineOutlined";
import RefreshIcon from "@mui/icons-material/Refresh";
import DownloadIcon from "@mui/icons-material/Download";
import FilterListIcon from "@mui/icons-material/FilterList";
// import Template from "./Template";

const JobTable = ({
  setLogs,
  setWell,
  setRigsId,
  setAllJobsData,
  setActiveJobsData,
  pageIndex,
  setPageIndex,
  pageSize,
  setPageSize,
  pageIndexFinish,
  setPageIndexFinish,
  pageSizeFinish,
  setPageSizeFinish,
}) => {
  const {
    liveJobList,
    liveJobListTotalRecords,
    jobList,
    finishList,
    finishListTotalRecords,
    dataqualityChartData,
  } = useSelector((state) => state.data);

  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();
  const [tabValue, setTabValue] = useState();
  const dispatch = useDispatch();
  const liveColumns = useMemo(
    () => [
      {
        accessorKey: "name",
        header: "Name",
        // enableEditing: false,
        enableGlobalFilterModes: true,
        size: 50,
        width: "20%",
      },
      {
        accessorKey: "rigId",
        header: "Rig Name",
        enableEditing: false,
        enableGlobalFilterModes: true,
        size: 10,
      },
      {
        accessorKey: "assetId",
        header: "Well Name",
        enableEditing: false,
        enableGlobalFilterModes: true,
        size: 10,
      },
      // {
      //   accessorKey: "status",
      //   header: t("jobStatus"),
      //   enableEditing: false,
      //   enableGlobalFilterModes: true,
      //   size: 10,
      // },
      {
        accessorKey: "recordIn",
        header: t("jobRecordsIn"),
        enableEditing: false,
        enableGlobalFilterModes: true,
        size: 10,
        muiTableBodyCellProps: {
          sx: {
            textAlign: "center",
          },
        },
      },
      {
        accessorKey: "recordOut",
        header: t("jobRecordsOut"),
        enableEditing: false,
        enableGlobalFilterModes: true,
        size: 10,
        muiTableBodyCellProps: {
          sx: {
            textAlign: "center",
          },
        },
      },
    ],
    [t]
  );

  sessionStorage.setItem("activePageSize", pageSize);
  sessionStorage.setItem("finishPageSize", pageSizeFinish);

  const historicalColumns = useMemo(
    () => [
      {
        accessorKey: "name",
        header: "Name",
        enableEditing: false,
      },
      {
        accessorKey: "modifieddate",
        header: "Date",
        enableEditing: false,
        Cell: ({ cell }) => (
          <>{dayjs(cell.value).format("YYYY-MM-DD HH:mm:ss")}</>
        ),
      },
      {
        accessorKey: "interval",
        header: "Interval Time",
        enableEditing: false,
      },
      {
        accessorKey: "configurable",
        header: "Configuration",
        enableEditing: false,
        Cell: ({ cell }) => <Switch checked={cell.value} readOnly />,
      },
    ],
    [t]
  );

  useEffect(() => {
    sessionStorage.setItem("activeTab", 0);
    const storedTabValue = sessionStorage.getItem("activeTab");
    if (storedTabValue) {
      setTabValue(parseInt(storedTabValue));
    }
  }, []);

  const handleTabChange = (event, newValue) => {
    if (newValue === 1) {
      dispatch(getLiveJobList("finish", pageSizeFinish, pageIndexFinish));
    } else {
      dispatch(getLiveJobList("active", pageSize, pageIndex));
      // dispatch(getLiveJobList('active', { pageNumber: 1, pageSize: 10 }))
    }
    setTabValue(newValue);
    sessionStorage.setItem("activeTab", newValue);
  };

  const tabsNew = {
    ...tabsStyle,
    boxShadow: "none",
    position: "relative",
    // backgroundColor: "red !important",
    display: "flex",
    flexGrow: 1,
    padding: "0px",
    margin: "0px",
    padding: "0px",
    margin: "0px",
  };

  const onClickEdting = (row) => {};
  const [selectedRowIndex, setSelectedRowIndex] = useState(0);

  useEffect(() => {
    setSelectedRowIndex(0);
    if (liveJobList.length > 0) {
      const defaultRowData = liveJobList[0];
      setAllJobsData(defaultRowData);
      setLogs(defaultRowData.name);
      setWell(defaultRowData.assetId);
      setRigsId(defaultRowData.rigId);
    }
  }, [liveJobList]);

  useEffect(() => {
    setSelectedRowIndex(0);
    if (finishList.length > 0 && tabValue === 1) {
      const defaultRowData = finishList[0];
      setAllJobsData(defaultRowData);
      setLogs(defaultRowData.name);
      setWell(defaultRowData.assetId);
      setRigsId(defaultRowData.rigId);
    }
  }, [finishList]);

  const handleRowClick = (row) => {
    setSelectedRowIndex(row.index);
    setAllJobsData(row.original);
    setLogs(row.original.name);
    setWell(row.original.assetId);
    setRigsId(row.original.rigId);
  };

  const excludedColumns = ["recordIn", "recordOut"];

  const handleRefresh = () => {
    dispatch(getLiveJobList("active", pageSize, pageIndex));
  };

  const handleFinishRefresh = () => {
    dispatch(getLiveJobList("finish", pageSizeFinish, pageIndexFinish));
  };

  const handlePageChange = (newPageIndex) => {
    setPageIndex(newPageIndex);
  };

  const handlePageFinishChange = (newPageIndex) => {
    setPageIndexFinish(newPageIndex);
  };

  const handleStartChange = () => {
    setPageIndex(0);
  };

  const handleStartFinishChange = () => {
    setPageIndexFinish(0);
  };

  const handleEndChange = () => {
    const totalPages = Math.ceil(liveJobListTotalRecords / pageSize);
    setPageIndex(totalPages - 1);
  };

  const handleEndFinishChange = () => {
    const totalPages = Math.ceil(finishListTotalRecords / pageSizeFinish);
    setPageIndexFinish(totalPages - 1);
  };

  const handlePageSizeChange = (newPageSize) => {
    setPageSize(newPageSize);
    setPageIndex(0);
  };

  const handlePageSizeFinishChange = (newPageSize) => {
    setPageSizeFinish(newPageSize);
    setPageIndexFinish(0);
  };

  return (
    <Fragment>
      <div style={{ marginTop: "25px", padding: "0px 0px" }}>
        <AppBar
          style={{
            boxShadow: "none",
            position: "relative",
            background: "none",
            padding: "0px",
            margin: "0px",
            backgroundColor: "#1e1e1e",
            color: "#c7c7c7",
            zIndex: "auto",
          }}
        >
          <Tabs
            value={tabValue}
            onChange={handleTabChange}
            aria-label="profile tabs"
            aria-setsize={"60px"}
            style={tabsNew}
          >
            <Tab
              label="Active Job"
              // style={tabStyle}
              sx={{
                ...tabStyle,
                backgroundColor: tabValue === 0 ? "#333" : "#1e1e1e",
                fontWeight: tabValue === 0 ? "bold" : "normal",
              }}
            />
            <Tab
              label="Finished Job"
              sx={{
                ...tabStyle,
                backgroundColor: tabValue === 1 ? "#333" : "#1e1e1e",
                fontWeight: tabValue === 1 ? "bold" : "normal",
              }}
            />
            <div
              className="offset-11 col-md-1"
              style={{
                position: "absolute",
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "end",
                top: "8px",
                paddingRight: "0px",
              }}
            >
              {location.pathname === "/dashboard" ? (
                <Tooltip title="Full screen">
                  <Link to={"/jobs"}>
                    <Button
                      size={"small"}
                      startIcon={<FullscreenIcon />}
                      onClick={() => {
                        navigate("/jobs");
                      }}
                      style={{ backgroundColor: "#1e1e1e", color: "white" }}
                    />
                  </Link>
                </Tooltip>
              ) : (
                <Tooltip title="Dashboard">
                  <Link to={"/dashboard"} className={"mr-2"}>
                    <Button
                      size={"small"}
                      startIcon={<HouseIcon />}
                      onClick={() => {
                        navigate("/dashboard");
                      }}
                      style={{ backgroundColor: "#1e1e1e", color: "white" }}
                    />
                  </Link>
                </Tooltip>
              )}
              <Tooltip title="refresh">
                <IconButton>
                  <RefreshIcon
                    style={{ color: "white" }}
                    onClick={handleRefresh}
                  />
                </IconButton>
              </Tooltip>
            </div>
          </Tabs>
        </AppBar>
        <div>
          <TabPanel value={tabValue} index={0}>
            <div
              style={{
                display: "block",
                position: "relative",
                overflow: "auto",
                backgroundColor: "#1e1e1e", // dark panel background
              }}
            >
              <div>
                <MaterialReactTable
                  muiTableHeadCellProps={{
                    sx: {
                      backgroundColor: "#2e2e2e", // dark head
                      color: "#ccc",
                    },
                  }}
                  muiTableHeadProps={{
                    sx: {
                      overflow: "auto",
                      backgroundColor: "#2e2e2e",
                      "&::-webkit-scrollbar": {
                        width: "12px",
                      },
                      "&::-webkit-scrollbar-thumb": {
                        backgroundColor: "#444", // darker thumb
                        borderRadius: "6px",
                      },
                      "&::-webkit-scrollbar-thumb:hover": {
                        backgroundColor: "#555",
                      },
                      "&::-webkit-scrollbar-track": {
                        backgroundColor: "#2e2e2e",
                      },
                    },
                  }}
                  muiTableHeadCellContentProps={{
                    sx: {
                      color: "#ccc !important", // text color
                      "& svg": {
                        color: "#ccc !important", // sort icon color
                      },
                    },
                  }}
                  muiTableBodyProps={{
                    sx: {
                      overflow: "auto",
                      scrollbarWidth: "thin",
                      backgroundColor: "#181818", // dark body
                      "&::-webkit-scrollbar": {
                        width: "10px",
                        backgroundColor: "#181818",
                      },
                      "&::-webkit-scrollbar-thumb": {
                        backgroundColor: "#444",
                        borderRadius: "6px",
                      },
                      "&::-webkit-scrollbar-thumb:hover": {
                        backgroundColor: "#555",
                      },
                      "&::-webkit-scrollbar-track": {
                        backgroundColor: "#23272f",
                      },
                      // "& tr:nth-of-type(odd)": {
                      //   backgroundColor: "#23272f",
                      // },
                      // "& tr:nth-of-type(even)": {
                      //   backgroundColor: "#181818",
                      // },
                      "& td": {
                        padding: "0.5rem",
                        borderBottom: "1px solid #333",
                        color: "#c7c7c7",
                      },
                    },
                  }}
                  muiTableContainerProps={{
                    sx: {
                      maxHeight: "59vh",
                      overflowY: "auto",
                      overflowX: "auto",
                      backgroundColor: "#181818", // dark container
                    },
                  }}
                  muiTablePaperProps={{
                    sx: {
                      boxShadow: "none",
                      height: "auto",
                      width: "100%",
                      position: "static",
                      display: "block",
                      overflowY: "auto",
                      overflowX: "auto",
                      backgroundColor: "#23272f", // dark table background
                      scrollbarWidth: "thin",
                      "&::-webkit-scrollbar": {
                        width: "12px",
                      },
                      "&::-webkit-scrollbar-thumb": {
                        backgroundColor: "#444",
                        borderRadius: "6px",
                      },
                      "&::-webkit-scrollbar-thumb:hover": {
                        backgroundColor: "#555",
                      },
                      "&::-webkit-scrollbar-track": {
                        backgroundColor: "#23272f",
                      },
                    },
                  }}
                  muiTableBodyRowProps={({ row }) => ({
                    onClick: () => handleRowClick(row),
                    sx: {
                      cursor: "pointer",
                      backgroundColor:
                        selectedRowIndex === row.index
                          ? "#1c1c1c"
                          : // : row.index % 2 === 0
                            // ? "#121212"
                            "#121212",
                      color: "#ccc",
                      borderBottom: "1px solid #333",
                      "&:hover": {
                        backgroundColor: "#2e2e2e",
                      },
                    },
                  })}
                  muiTableFooterCellProps={{
                    sx: {
                      backgroundColor: "#23272f",
                      color: "#ccc",
                    },
                  }}
                  columns={liveColumns}
                  data={
                    liveJobList.length > 0
                      ? liveJobList.filter((col) => col.status === "RUNNING")
                      : []
                  }
                  enableRowActions
                  enableColumnActions={true}
                  enableStickyHeader={true}
                  enableStickyFooter={true}
                  enableDensityToggle={false}
                  enableFullScreenToggle={false}
                  enableHiding={false}
                  positionActionsColumn="last"
                  editDisplayMode="row"
                  muiPaginationProps={({ table }) => ({
                    showRowsPerPage: true,
                  })}
                  rowCount={liveJobListTotalRecords}
                  muiTableHeadCellFilterTextFieldProps={{
                    sx: {
                      input: {
                        "&::placeholder": {
                          color: "#ffffff",
                          opacity: 1,
                        },
                      },
                    },
                  }}
                  renderTopToolbar={({ table }) => (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "end",
                        alignItems: "center",
                        padding: "0.5rem 1rem",
                        flexWrap: "wrap",
                        gap: "1rem",
                        background: "#181818",
                      }}
                    >
                      <TextField
                        variant="outlined"
                        size="small"
                        placeholder="Search..."
                        value={table.getState().globalFilter || ""}
                        onChange={(e) => table.setGlobalFilter(e.target.value)}
                        sx={{
                          minWidth: "250px",
                          input: { color: "#c7c7c7", background: "#272727" },
                          "& legend": {
                            display: "none",
                          },
                        }}
                      />
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "0.5rem",
                        }}
                      >
                        <Tooltip title="Show Filters">
                          <IconButton
                            onClick={() =>
                              table.setShowColumnFilters(
                                !table.getState().showColumnFilters
                              )
                            }
                          >
                            <FilterListIcon
                              sx={{ color: "#c7c7c7 !important" }}
                            />
                          </IconButton>
                        </Tooltip>
                        <Tooltip title="Create Template">
                          <Button
                            startIcon={<AddIcon />}
                            variant="contained"
                            style={{
                              // backgroundColor: "#286685",
                              // color: "white",
                              padding: "5px 10px",
                              background:
                                "linear-gradient(135deg, #4f4f4f, #1e1e1e)",
                              border: "1px solid #3a3a3a",
                              color: "#ffffff",
                              /* font-weight: 600; */
                              fontSize: "5px",
                              borderRadius: "6px",
                              cursor: "pointer",
                              boxShadow: "0 0 8px rgba(0, 0, 0, 0.6)",
                              transition:
                                "background 0.3s ease, transform 0.2s ease",
                            }}
                            onClick={() => navigate("/template")}
                          >
                            Create
                          </Button>
                        </Tooltip>
                      </div>
                    </div>
                  )}
                  enablePagination={false}
                  renderBottomToolbarCustomActions={({ table }) => (
                    <>
                      <div style={{ marginLeft: "auto", color: "#c7c7c7" }}>
                        <span>Rows per Page </span>&nbsp;
                        <FormControl variant="standard" size="small">
                          <Select
                            value={pageSize}
                            onChange={(e) =>
                              handlePageSizeChange(Number(e.target.value))
                            }
                            sx={{
                              color: "#c7c7c7",
                              ".MuiSelect-icon": { color: "#c7c7c7" },
                              ".MuiOutlinedInput-notchedOutline": {
                                borderColor: "#444",
                              },
                            }}
                          >
                            <MenuItem value={5}>5</MenuItem>
                            <MenuItem value={10}>10</MenuItem>
                            <MenuItem value={20}>20</MenuItem>
                            <MenuItem value={50}>50</MenuItem>
                            <MenuItem value={100}>100</MenuItem>
                          </Select>
                        </FormControl>
                        &nbsp;
                        <span>
                          {pageIndex * pageSize + 1}-
                          {Math.min(
                            pageIndex * pageSize + pageSize,
                            liveJobListTotalRecords
                          )}{" "}
                          of &nbsp;
                          {liveJobListTotalRecords}&nbsp;
                        </span>
                        <FirstPageIcon
                          onClick={() => {
                            if (pageIndex !== 0) {
                              handleStartChange();
                            }
                          }}
                          style={{
                            cursor: pageIndex === 0 ? "not-allowed" : "pointer",
                            color:
                              pageIndex === 0
                                ? "rgba(255,255,255,0.26)"
                                : "#c7c7c7",
                          }}
                        />
                        <NavigateBeforeIcon
                          onClick={() => {
                            if (pageIndex !== 0) {
                              handlePageChange(pageIndex - 1);
                            }
                          }}
                          style={{
                            cursor: pageIndex === 0 ? "not-allowed" : "pointer",
                            color:
                              pageIndex === 0
                                ? "rgba(255,255,255,0.26)"
                                : "#c7c7c7",
                          }}
                        />
                        <NavigateNextIcon
                          onClick={() => {
                            if (
                              (pageIndex + 1) * pageSize <
                              liveJobListTotalRecords
                            ) {
                              handlePageChange(pageIndex + 1);
                            }
                          }}
                          style={{
                            cursor:
                              (pageIndex + 1) * pageSize >=
                              liveJobListTotalRecords
                                ? "not-allowed"
                                : "pointer",
                            color:
                              (pageIndex + 1) * pageSize >=
                              liveJobListTotalRecords
                                ? "rgba(255,255,255,0.26)"
                                : "#c7c7c7",
                          }}
                        />
                        <LastPageIcon
                          onClick={() => {
                            if (
                              (pageIndex + 1) * pageSize <
                              liveJobListTotalRecords
                            ) {
                              handleEndChange();
                            }
                          }}
                          style={{
                            cursor:
                              (pageIndex + 1) * pageSize >=
                              liveJobListTotalRecords
                                ? "not-allowed"
                                : "pointer",
                            color:
                              (pageIndex + 1) * pageSize >=
                              liveJobListTotalRecords
                                ? "rgba(255,255,255,0.26)"
                                : "#c7c7c7",
                          }}
                        />
                      </div>
                    </>
                  )}
                  renderRowActions={({ row, table }) => (
                    <Box
                      sx={{ display: "flex", flexWrap: "nowrap", gap: "8px" }}
                    >
                      <Tooltip title="Download Log's">
                        <IconButton
                          onClick={() => {
                            dispatch(getDownloadJobs(row.original));
                          }}
                        >
                          <DownloadIcon sx={{ color: "#c7c7c7" }} />
                        </IconButton>
                      </Tooltip>
                    </Box>
                  )}
                />
              </div>
            </div>
          </TabPanel>
          {/* {jobList.length > 0 ?  */}
          <TabPanel value={tabValue} index={1}>
            <div
              style={{
                display: "block",
                position: "relative",
                // height: "70%",
                overflow: "auto",
                backgroundColor: "#1e1e1e",
              }}
            >
              <div>
                <MaterialReactTable
                  muiTableHeadCellProps={{
                    sx: {
                      backgroundColor: "#2e2e2e", // dark head
                      color: "#ccc",
                    },
                  }}
                  muiTableHeadProps={{
                    sx: {
                      overflow: "auto",
                      backgroundColor: "#2e2e2e",
                      "&::-webkit-scrollbar": {
                        width: "12px",
                      },
                      "&::-webkit-scrollbar-thumb": {
                        backgroundColor: "#444", // darker thumb
                        borderRadius: "6px",
                      },
                      "&::-webkit-scrollbar-thumb:hover": {
                        backgroundColor: "#555",
                      },
                      "&::-webkit-scrollbar-track": {
                        backgroundColor: "#2e2e2e",
                      },
                    },
                  }}
                  muiTableHeadCellContentProps={{
                    sx: {
                      color: "#ccc !important", // text color
                      "& svg": {
                        color: "#ccc !important", // sort icon color
                      },
                    },
                  }}
                  muiTableBodyProps={{
                    sx: {
                      overflow: "auto",
                      scrollbarWidth: "thin",
                      backgroundColor: "#181818", // dark body
                      "&::-webkit-scrollbar": {
                        width: "12px",
                      },
                      "&::-webkit-scrollbar-thumb": {
                        backgroundColor: "#444",
                        borderRadius: "6px",
                      },
                      "&::-webkit-scrollbar-thumb:hover": {
                        backgroundColor: "#555",
                      },
                      "&::-webkit-scrollbar-track": {
                        backgroundColor: "#23272f",
                      },
                      // "& tr:nth-of-type(odd)": {
                      //   backgroundColor: "#23272f",
                      // },
                      // "& tr:nth-of-type(even)": {
                      //   backgroundColor: "#181818",
                      // },
                      "& td": {
                        padding: "0.5rem",
                        borderBottom: "1px solid #333",
                        color: "#c7c7c7",
                      },
                    },
                  }}
                  muiTableContainerProps={{
                    sx: {
                      maxHeight: "59vh",
                      overflowY: "auto",
                      overflowX: "auto",
                      backgroundColor: "#181818", // dark container
                    },
                  }}
                  muiTablePaperProps={{
                    sx: {
                      boxShadow: "none",
                      height: "auto",
                      width: "100%",
                      position: "static",
                      display: "block",
                      overflowY: "auto",
                      overflowX: "auto",
                      backgroundColor: "#23272f", // dark table background
                      scrollbarWidth: "thin",
                      "&::-webkit-scrollbar": {
                        width: "12px",
                      },
                      "&::-webkit-scrollbar-thumb": {
                        backgroundColor: "#444",
                        borderRadius: "6px",
                      },
                      "&::-webkit-scrollbar-thumb:hover": {
                        backgroundColor: "#555",
                      },
                      "&::-webkit-scrollbar-track": {
                        backgroundColor: "#23272f",
                      },
                    },
                  }}
                  muiTableBodyRowProps={({ row }) => ({
                    onClick: () => handleRowClick(row),
                    sx: {
                      cursor: "pointer",
                      backgroundColor:
                        selectedRowIndex === row.index
                          ? "#1c1c1c"
                          : // : row.index % 2 === 0
                            // ? "#121212"
                            "#121212",
                      color: "#ccc",
                      borderBottom: "1px solid #333",
                      "&:hover": {
                        backgroundColor: "#2e2e2e",
                      },
                    },
                  })}
                  muiTableFooterCellProps={{
                    sx: {
                      backgroundColor: "#23272f",
                      color: "#ccc",
                    },
                  }}
                  columns={liveColumns.filter(
                    (col) => !excludedColumns.includes(col.accessorKey)
                  )}
                  data={finishList || []}
                  enableRowActions
                  enableStickyHeader={true}
                  enableStickyFooter={true}
                  enableColumnActions={false}
                  enableDensityToggle={false}
                  enableFullScreenToggle={false}
                  enableFilters={true}
                  createDisplayMode="custom"
                  enableHiding={false}
                  positionActionsColumn="last"
                  editDisplayMode="row"
                  muiPaginationProps={({ table }) => ({
                    showRowsPerPage: true,
                  })}
                  rowCount={finishListTotalRecords}
                  renderTopToolbar={({ table }) => (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "end",
                        alignItems: "center",
                        padding: "0.5rem 1rem",
                        flexWrap: "wrap",
                        gap: "1rem",
                        background: "#181818",
                      }}
                    >
                      <TextField
                        variant="outlined"
                        size="small"
                        placeholder="Search..."
                        value={table.getState().globalFilter || ""}
                        onChange={(e) => table.setGlobalFilter(e.target.value)}
                        sx={{
                          minWidth: "250px",
                          input: { color: "#c7c7c7", background: "#272727" },
                          "& legend": {
                            display: "none",
                          },
                        }}
                      />
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "0.5rem",
                        }}
                      >
                        <Tooltip title="Show Filters">
                          <IconButton
                            onClick={() =>
                              table.setShowColumnFilters(
                                !table.getState().showColumnFilters
                              )
                            }
                          >
                            <FilterListIcon
                              sx={{ color: "#c7c7c7 !important" }}
                            />
                          </IconButton>
                        </Tooltip>
                      </div>
                    </div>
                  )}
                  enablePagination={false}
                  renderBottomToolbarCustomActions={({ table }) => (
                    <>
                      <div style={{ marginLeft: "auto", color: "#c7c7c7" }}>
                        <span>Rows per Page </span>&nbsp;
                        <FormControl variant="standard" size="small">
                          <Select
                            value={pageSizeFinish}
                            onChange={(e) =>
                              handlePageSizeFinishChange(Number(e.target.value))
                            }
                            sx={{
                              color: "#c7c7c7",
                              ".MuiSelect-icon": { color: "#c7c7c7" },
                              ".MuiOutlinedInput-notchedOutline": {
                                borderColor: "#444",
                              },
                            }}
                          >
                            <MenuItem value={5}>5</MenuItem>
                            <MenuItem value={10}>10</MenuItem>
                            <MenuItem value={20}>20</MenuItem>
                            <MenuItem value={50}>50</MenuItem>
                            <MenuItem value={100}>100</MenuItem>
                          </Select>
                        </FormControl>
                        &nbsp;
                        <span>
                          {pageIndexFinish * pageSizeFinish + 1}-
                          {Math.min(
                            pageIndexFinish * pageSizeFinish + pageSizeFinish,
                            finishListTotalRecords
                          )}{" "}
                          of &nbsp;
                          {finishListTotalRecords}&nbsp;
                        </span>
                        <FirstPageIcon
                          onClick={() => {
                            if (pageIndexFinish !== 0) {
                              handleStartFinishChange();
                            }
                          }}
                          style={{
                            cursor:
                              pageIndexFinish === 0 ? "not-allowed" : "pointer",
                            color:
                              pageIndexFinish === 0
                                ? "rgba(255,255,255,0.26)"
                                : "inherit",
                          }}
                        />
                        <NavigateBeforeIcon
                          onClick={() => {
                            if (pageIndexFinish !== 0) {
                              handlePageFinishChange(pageIndexFinish - 1);
                            }
                          }}
                          style={{
                            cursor:
                              pageIndexFinish === 0 ? "not-allowed" : "pointer",
                            color:
                              pageIndexFinish === 0
                                ? "rgba(255,255,255,0.26)"
                                : "inherit",
                          }}
                        />
                        <NavigateNextIcon
                          onClick={() => {
                            if (
                              (pageIndexFinish + 1) * pageSizeFinish <
                              finishListTotalRecords
                            ) {
                              handlePageFinishChange(pageIndexFinish + 1);
                            }
                          }}
                          style={{
                            cursor:
                              (pageIndexFinish + 1) * pageSizeFinish >=
                              finishListTotalRecords
                                ? "not-allowed"
                                : "pointer",
                            color:
                              (pageIndexFinish + 1) * pageSizeFinish >=
                              finishListTotalRecords
                                ? "rgba(255,255,255,0.26)"
                                : "inherit",
                          }}
                        />
                        <LastPageIcon
                          onClick={() => {
                            if (
                              (pageIndexFinish + 1) * pageSizeFinish <
                              finishListTotalRecords
                            ) {
                              handleEndFinishChange();
                            }
                          }}
                          style={{
                            cursor:
                              (pageIndexFinish + 1) * pageSizeFinish >=
                              finishListTotalRecords
                                ? "not-allowed"
                                : "pointer",
                            color:
                              (pageIndexFinish + 1) * pageSizeFinish >=
                              finishListTotalRecords
                                ? "rgba(255,255,255,0.26)"
                                : "inherit",
                          }}
                        />
                      </div>
                    </>
                  )}
                  renderRowActions={({ row, table, index }) => (
                    <Box
                      sx={{ display: "flex", flexWrap: "nowrap", gap: "8px" }}
                    >
                      <Tooltip title="Download">
                        <IconButton
                          sx={{ color: "#c7c7c7" }}
                          onClick={() => {
                            dispatch(getDownloadJobs(row.original));
                            // dispatch(getJobData(row.original, 'N'))
                          }}
                        >
                          <DownloadIcon sx={{ color: "#c7c7c7" }} />
                        </IconButton>
                      </Tooltip>
                    </Box>
                  )}
                />
              </div>
            </div>
          </TabPanel>
        </div>
      </div>
    </Fragment>
  );
};

export default JobTable;
